module.exports = __webpack_public_path__ + "static/img/DLD_g.f7d48efb.png";